/*
 * Drag-to-dismiss for the mobile menu sub panels.
 *
 * The panels are bottom sheets (see component-mega-menu-nested.css), so pulling
 * one back down is the gesture people expect. Closing reuses the vendor's own
 * back button rather than reimplementing it: assets/header.js removes .active,
 * waits 400ms and then drops the `open` attribute, and duplicating that timing
 * here would drift the moment either side changes.
 *
 * Delegated from the document because panels are created by Liquid on every page
 * and nested arbitrarily deep; there is nothing to bind to per instance.
 */
(() => {
  const SHEET = '.menu-drawer__submenu';
  const HANDLE = '.menu-drawer__grabber';
  const DRAGGING = 'menu-drawer__submenu--dragging';
  /* Far enough that a stray thumb movement while reading does not close the
     panel, short enough that a deliberate pull does. */
  const CLOSE_AFTER = 110;

  let sheet = null;
  let startY = 0;
  let movedY = 0;

  const reset = () => {
    if (!sheet) return;
    sheet.classList.remove(DRAGGING);
    sheet.style.transform = '';
    sheet = null;
    movedY = 0;
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      const handle = event.target.closest(HANDLE);
      if (!handle) return;

      const panel = handle.closest(SHEET);
      /* Only a panel that is actually open can be dragged shut. */
      if (!panel || !panel.parentElement.classList.contains('active')) return;

      sheet = panel;
      startY = event.clientY;
      movedY = 0;
      sheet.classList.add(DRAGGING);
      handle.setPointerCapture?.(event.pointerId);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!sheet) return;
      /* Downward only. Allowing negative values would let the sheet be dragged
         up past the top of the drawer, where there is nothing behind it. */
      movedY = Math.max(0, event.clientY - startY);
      sheet.style.transform = `translateY(${movedY}px)`;
    },
    { passive: true }
  );

  const release = () => {
    if (!sheet) return;
    const shouldClose = movedY > CLOSE_AFTER;
    const back = sheet.querySelector(':scope > .menu-drawer__item-back-link');
    reset();
    /* After reset, so the sheet animates down from its resting position through
       the CSS transition rather than jumping from wherever the finger left it. */
    if (shouldClose && back) back.click();
  };

  document.addEventListener('pointerup', release, { passive: true });
  document.addEventListener('pointercancel', reset, { passive: true });
})();
